import * as React from 'react';
import { Callout } from 'office-ui-fabric-react/lib/components/Callout';
import { observer } from 'mobx-react';
import { LocationPersonaControlViewState } from '../data/schema/LocationPersonaControlViewState';

import createLocationPersonaFromPostalAddress from '../utils/createLocationPersonaFromPostalAddress';
import LocationCompactCard from './LocationCompactCard';
import LocationExpandedCard from './LocationExpandedCard';

import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';

let styles = require('./LocationCard.scss');

export interface LocationCardProps {
    name: string;
    postalAddress: PersonaPostalAddress;
    target: HTMLElement;
    onDismiss: (ev?: any) => void;
}

@observer
export class LocationCard extends React.Component<LocationCardProps, any> {
    private locationPersona: LocationPersonaControlViewState;

    constructor(props: LocationCardProps) {
        super(props);

        this.locationPersona = createLocationPersonaFromPostalAddress(
            props.postalAddress,
            props.name
        );
    }

    render() {
        let { target, onDismiss } = this.props;

        return (
            <Callout
                isBeakVisible={false}
                target={target}
                onDismiss={onDismiss}
                setInitialFocus={true}>
                <div className={styles.container} onMouseLeave={onDismiss}>
                    <LocationCompactCard locationPersona={this.locationPersona} />
                    <LocationExpandedCard locationPersona={this.locationPersona} />
                </div>
            </Callout>
        );
    }
}
